export const FileType = {
    Firmware: 0,
    Document: 1,
    GSC: 2
}